import React, { Component } from 'react';
// import StarRatings from 'react-star-ratings';
// import { Tooltip } from 'reactstrap';
import cjquery from 'jquery';

import language from '../../../../assets/languages/language';
import App_data from '../../../config/App_data';
import ValidateSaveReportIcon from '../../../Common/ValidateSaveReportIcon';
import AlertMessage from '../../../config/alertMessage';
import FD from '../../../RestAPI/fetchData';
import AppRoutes from '../../../config/AppRoutes';
import Loader from '../../../../common/loader';
import { Col, Row } from 'reactstrap';
import { renderHTMLContent } from '../../../../common/function';

const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
/* eslint-disable */
class GMATCases extends Component {
  // =============================== TODO START =======================//
  constructor(props) {
    super(props);
    this.state = {
      isExpand: false,
      successAlert: false,
      alert_status: false,
      MessageTitle: App_data.messageTitle,
      MessageContent: AlertMessage.messageContent_gmat,
      questions: [],
      all_questions_state: [],
      token: '',
      idname: '',
      ValidToken: false,
      reportLoading: false,
      chapter_id: '',
      offset: 0,
      limit: 1,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      choice_e: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: 'pause_btn icon-control-pause',
      save_text: `${language.LC().SAVE_QUESTION}`,
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      getComments: [],
      comment_data: '',
      flash_data: [],
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: this.props.params.timer ? this.props.params.timer : 0,
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      question_length: '',
      timer_stop: false,
      timer_tag: `${language.LC().STOP}`,
      chaptername: '',
      all_cases: [],
      cases_display: '',
      cases_name: '',
      cases_length: '',
      case_id: '',
      cases_offset: '',
      casesquestion_length: '',
      chapters: '',
      display_loader: '',
      selectedmenu: 'cfa_2',
      subscriptionstatus: '',
      display_subcription: 'hide_block',
      display_cases: 'show_block',
      showCompletionQuestion: false,
      markAsCompleted: false,
      markAsNotCompleted: false,
      markCompleted: true,
      cases: [],
      exam_type: 'cfa_2',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      forumComment: '',
      category: 'CFA Level 2',
      tags: ['cfa-2', 'cfa', 'question', 'case'],
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      hide_case_left_arrow: '',
      hide_case_right_arrow: '',
      hide_question_left_arrow: '',
      hide_question_right_arrow: '',
      display_main_loader: 'hide_block',
      top_50: '',
      question_no: 1,
      quiz_id: this.props.params.quiz_id,
      offset: this.props.params.offset ? parseInt(this.props.params.offset) : 0,
      display_question: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  saveForumComment(e) {
    this.setState({ forumComment: e.target.value });
  }

  changeCompletionStatus(e) {
    e.preventDefault();
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      case_no: this.state.cases.casesingleData.case_number,
      completion_status: this.state.markAsCompleted,
      exam_type: this.state.exam_type,
      chapter_id: this.props.params.chapterid,
    };
    if (this.state.markAsCompleted === true) {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/updateCases', data).then(resp => {
        if (resp.success) {
          this._getReadings();
        }
      });
    } else {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/updateCases', data).then(resp => {
        if (resp.success) {
          this._getReadings();
        }
      });
    }
  }

  markCompleted() {
    this.setState({
      markAsCompleted: true,
      markAsNotCompleted: false,
      markCompleted: false,
    });
  }

  markNotCompleted() {
    this.setState({
      markAsCompleted: false,
      markAsNotCompleted: true,
      markCompleted: false,
    });
  }

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }
  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  /*
  ---------------------------------------------
    Function to change, time every second
  ---------------------------------------------
  */
  //Function to change time every second and store in database
  tick() {
    if (this.state.count != 0) {
      var count_value = this.state.count - 1;
      var insert_time = {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        user_time_value: count_value,
      };
      FD.callAPI(App_data.backend_api + '/gmat_quizes/insertTimer', insert_time).then(resp => {
        if (resp.success) {
          // console.log('Timer Update Successfull');
        } else {
          // console.log('Fail Timer Update');
        }
      });
      this.setState({ count: this.state.count - 1 });
      this.setState({ timer_display: 'card-block' });
    } else {
      this.context.router.push({
        pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(
          ':quiz_id',
          this.state.quiz_id,
        ).replace(':status_send', 'completed'),
      });
    }
    // if (this.state.timer_value == this.state.count) {
    //   // this.setState({count_end_message:'Time&#8242;s Up'});
    //   this.setState({ timer_display: 'card hide_block' });
    // }
  }

  /*
  -------------------------------------------------
    Function to redirect page to readings page
  -------------------------------------------------
  */
  _getReadings = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUESTION_BANK_READING.replace(':id', this.props.params.chapterid),
    });
  };

  /*
  -----------------------------------------------------------------------------
    Function to check Right Or Wrong Answered and displayed clicked box
  -----------------------------------------------------------------------------
  */
  _getAnswer = (choice, questionId) => {
    this.setState({ clicked: true, choice: 'choice_' + choice }, () => {
      // console.log('choice ----> ', this.state.choice);
    });
    if (choice === 'a') {
      this.setState({
        choice_a: 'answer_box clicked_box',
        choice_b: 'answer_box',
        choice_c: 'answer_box',
        choice_d: 'answer_box',
        choice_e: 'answer_box',
      });
    } else if (choice === 'b') {
      this.setState({
        choice_b: 'answer_box clicked_box',
        choice_a: 'answer_box',
        choice_c: 'answer_box',
        choice_d: 'answer_box',
        choice_e: 'answer_box',
      });
    } else if (choice === 'c') {
      this.setState({
        choice_c: 'answer_box clicked_box',
        choice_a: 'answer_box',
        choice_b: 'answer_box',
        choice_d: 'answer_box',
        choice_e: 'answer_box',
      });
    } else if (choice === 'd') {
      this.setState({
        choice_d: 'answer_box clicked_box',
        choice_a: 'answer_box',
        choice_b: 'answer_box',
        choice_c: 'answer_box',
        choice_e: 'answer_box',
      });
    } else if (choice === 'e') {
      this.setState({
        choice_e: 'answer_box clicked_box',
        choice_a: 'answer_box',
        choice_b: 'answer_box',
        choice_c: 'answer_box',
        choice_d: 'answer_box',
      });
    }
    // const result = getDeviceDetails();
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: questionId,
      caseIndex: this.props.params.case_offset,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };

    if (!this.state.validated) {
      //  console.log('quiz id  '+this.state.quiz_id+'---question_id---'+this.state.all_question_id[this.state.offset]+'-----right answer-----'+right_answer);
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        question_id: this.state.all_question_id[this.state.offset],
        answer: right_answer,
        reading_id: item.reading_id,
      };
      FD.callAPI(App_data.backend_api + '/gmat_quizes/answerQuiz', data).then(resp => {
        if (resp.success) {
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: this.state.all_question_id[this.state.offset],
            right_answer: right_answer,
            time_done: 0,
          };
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveStats', data).then(resp => {
            if (resp.success) {
            } else {
            }
          });
          this.setState({ ValidToken: true });
          this.setState({ validated: true });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/trackUserRecord', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
      }
    });
  };

  /*
  ------------------------------------------------------------------------------
    Function to show Correct box and display right answer and store in database
  -------------------------------------------------------------------------------
    */
  _getResult = (item, e) => {
    if (this.state.clicked) {
      clearInterval(this.timer);
      // const chosen_answer = this.state.choice;
      var right_answer = 0;
      this.setState({ result_block: 'card show_block' });
      //console.log(item);
      if (item.right_choice === this.state.choice) {
        right_answer = 1;
        if (this.state.choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box success' });
        } else if (this.state.choice === 'choice_b') {
          this.setState({
            choice_b: 'answer_box success',
          });
        } else if (this.state.choice === 'choice_c') {
          this.setState({
            choice_c: 'answer_box success',
          });
        } else if (this.state.choice === 'choice_d') {
          this.setState({
            choice_d: 'answer_box success',
          });
        } else if (this.state.choice === 'choice_e') {
          this.setState({
            choice_e: 'answer_box success',
          });
        }
        this.setState({
          result: 'CORRECT',
          text_color: 'card-header text_success',
          result_block: 'card show_block',
        });
      } else {
        right_answer = 0;
        if (this.state.choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box failure' });
        } else if (this.state.choice === 'choice_b') {
          this.setState({
            choice_b: 'answer_box failure',
          });
        } else if (this.state.choice === 'choice_c') {
          this.setState({
            choice_c: 'answer_box failure',
          });
        } else if (this.state.choice === 'choice_d') {
          this.setState({
            choice_d: 'answer_box failure',
          });
        } else if (this.state.choice === 'choice_e') {
          this.setState({
            choice_e: 'answer_box failure',
          });
        }
        if (item.right_choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box success' });
        } else if (item.right_choice === 'choice_b') {
          this.setState({
            choice_b: 'answer_box success',
          });
        } else if (item.right_choice === 'choice_c') {
          this.setState({
            choice_c: 'answer_box success',
          });
        } else if (item.right_choice === 'choice_d') {
          this.setState({
            choice_d: 'answer_box success',
          });
        } else if (item.right_choice === 'choice_e') {
          this.setState({
            choice_e: 'answer_box success',
          });
        }
        this.setState({
          text_color: 'card-header text_failure',
          result: 'INCORRECT',
          result_block: 'card show_block',
        });
      }

      if (!this.state.validated) {
        //  console.log('quiz id  '+this.state.quiz_id+'---question_id---'+this.state.all_question_id[this.state.offset]+'-----right answer-----'+right_answer);
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          quiz_id: this.state.quiz_id,
          question_id: this.state.all_question_id[this.state.offset],
          answer: right_answer,
          reading_id: item.reading_id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_quizes/answerQuiz', data).then(resp => {
          if (resp.success) {
            var data = {
              token: this.state.token,
              idname: this.state.idname,
              question_id: this.state.all_question_id[this.state.offset],
              right_answer: right_answer,
              time_done: 0,
            };
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveStats', data).then(resp => {
              if (resp.success) {
              } else {
              }
            });
            this.setState({ ValidToken: true });
            this.setState({ validated: true });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        });
      }
    }
  };

  /*Function to start or stop timer*/
  _timer_funct = (item, e) => {
    // this.setState({timer_stop:!this.state.timer_stop});
    if (this.state.timer_stop) {
      this.setState({ timer_stop: false });
      /*this.setState({timer_tag:'Stop'});   */
      this.setState({ timerstopbtn: 'pause_btn icon-control-pause' });
      clearInterval(this.timer);
      this.timer = setInterval(this.tick.bind(this), 1000);
    } else {
      this.setState({ timer_stop: true });
      this.setState({ timerstopbtn: 'pause_btn icon-control-play' });
      /*    this.setState({timer_tag:'Start'}); */
      clearInterval(this.timer);
    }
  };

  /*
  ------------------------------------------------------------------------
     Function to Display Saved Question on button and save in database
  -------------------------------------------------------------------------
    */
  _saveQuestion = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      chapter_id: this.props.params.chapterid,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      // return;
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/unsaveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            bookmarkColor: '',
            save_text: `${language.LC().SAVE_QUESTION}`,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    } else {
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveQuestion', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };

  /*
  -------------------------------------
    Function to give star rattings
  -------------------------------------
    */
  onStarClick(item, nextValue, prevValue, name) {
    if (prevValue !== nextValue) {
      let params = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: item.id,
        ratting: nextValue,
      };
      FD.callAPI(App_data.backend_api + '/gmat_question_bank/UpdateGMATRatting', params).then(
        response => {
          if (response.success) {
            this.setState({ rated: 1, ratting_text: 'Rated ' });
          }
        },
      );
    }

    this.setState({ rating: nextValue });
    let params = {
      token: this.state.token,
      question_id: item.id,
      idname: this.state.idname,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
          ratting: nextValue,
        };
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.map(items =>
              this.setState({ rating: items.ratting, ratting_text: 'Rated ' }),
            );
          } else {
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
              response => {
                if (response.success) {
                  this.setState({ rated: 1, ratting_text: 'Rated ' });
                }
              },
            );
          }
        } else {
          FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveGMATRatting', params).then(
            response => {
              if (response.success) {
                this.setState({
                  rated: 1,
                  ratting_text: `Rated ${nextValue} stars`,
                });
              }
            },
          );
        }
      },
    );
  }

  /*
  --------------------------------------
    Function to show Report box
  -------------------------------------
    */
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  /*
  -------------------------------------------
    Funcion to save new report question
  -------------------------------------------
    */
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    // const result = getDeviceDetails();
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
      caseIndex: this.props.params.case_offset,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/reportQuestion', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  /*
  ---------------------------------
    Function to hide Report box
  ---------------------------------
  */
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  /*
  -----------------------------------
    Function to toggle Comment box
  ------------------------------------
  */
  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  /*
  -----------------------------------------------------------
    Function to save comment And display new comment
  -----------------------------------------------------------
  */
  _saveComment = (item, forumData) => {
    if (document.getElementById('ques_comment').value === '') {
      return;
    }
    var comment = document.getElementById('ques_comment').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
    };
    /*Api to save comment*/
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveComment', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('ques_comment').value = '';
        this.setState({ forumComment: '' });
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
        };
        const { location } = this.props;
        const { pathname } = location;
        var titleUpdated = `${language.LC().Q}${item.question_number} ${language.LC().CASE_STUDY} ${item.case_id
          } - ${this.state.cases_name}`;
        var data = {
          idname: this.state.idname,
          token: this.state.token,
          title: titleUpdated,
          description: forumData,
          tags: this.state.tags,
          category: this.state.category,
          postFrom: 'app',
          appQuestion: true,
          quesID: item.id,
          comment: comment,
          caseId: item.case_id,
          caseRedirectURL: `${App_data.frontend_url}${pathname}`,
        };
        FD.callAPI(App_data.backend_api + '/forum/savePost', data).then(resp => {
          if (resp.success) {
            this.setState({ title: '', description: '' });
            /*Api to get comment*/
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
              response => {
                var comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                if (response.success) {
                  this.setState({ ValidToken: true });
                  //this.setState({getComments : resp.comments});
                  if (response.comments.length > 0) {
                    comments = response.comments.map((items, index) => (
                      //alert(items.id)
                      <li key={index}>
                        {response.user_id === items.uid ? (
                          <ul className='icon_list'>
                            <li>
                              <a
                                className='pointer_class'
                                onClick={this._editComment.bind(this, items)}
                              >
                                <i className='fa fa-pencil' />
                              </a>
                            </li>
                            <li>
                              <a
                                className='pointer_class'
                                onClick={this._deleteComment.bind(this, items)}
                              >
                                <i className='fa fa-close' />
                              </a>
                            </li>
                          </ul>
                        ) : (
                          <ul />
                        )}
                        <h4>
                          By {items.username}, {new Date(items.createdAt).toDateString()}
                        </h4>
                        <p>{items.comment}</p>
                      </li>
                    ));

                    this.setState({ comment_data: comments });
                  } else {
                    this.setState({ comment_data: comments });
                  }
                } else {
                  this.setState({ comment_data: comments, ValidToken: false });
                }
                return response;
              },
            );
          }
        });
      } else {
        this.setState({ ValidToken: false });
      }
      /// return resp;
    });
  };

  /*
  -----------------------------------------
   Function to Edit particular comment
  -----------------------------------------
  */
  _editComment = async (item, e) => {
    document.getElementById('ques_comment').value = item.comment;
    await this.setState({
      forumComment: item.comment,
      comment_update: 'btn btn-primary active pointer_class margin_bottom_20',
      comment_save: 'hide_block',
      comment_update_id: item.id,
    });
  };

  /*
  -----------------------------------
      Function to Update Comment
  -----------------------------------
*/
  _updateComment = (item, e) => {
    if (document.getElementById('ques_comment').value === '') {
      return;
    }
    var comment = document.getElementById('ques_comment').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      comment_id: this.state.comment_update_id,
      comment: comment,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/updateComment', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('ques_comment').value = '';
        this.setState({ forumComment: '' });
        this.setState({
          comment_update: 'hide_block',
          comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
          comment_update_id: '',
        });
        document.getElementById('ques_comment').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;

            if (response.success) {
              this.setState({ ValidToken: true });
              //this.setState({getComments : resp.comments});
              if (response.comments.length > 0) {
                comments = response.comments.map((items, index) => (
                  //alert(items.id)
                  <li key={index}>
                    {response.user_id === items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      By {items.username}, {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));

                this.setState({ comment_data: comments });
              } else {
                this.setState({ comment_data: comments });
              }
            } else {
              this.setState({ comment_data: comments, ValidToken: false });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  /*
  --------------------------------------------
    Function to delete particular comment
  --------------------------------------------
  */
  _deleteComment = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      comment: item,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/deleteComment', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('ques_comment').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.question_id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
            if (response.success) {
              this.setState({ ValidToken: true });
              //this.setState({getComments : resp.comments});
              if (response.comments.length > 0) {
                comments = response.comments.map((items, index) => (
                  <li key={index}>
                    {response.user_id === items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username},{' '}
                      {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));

                this.setState({ comment_data: comments });
              } else {
                this.setState({ comment_data: comments });
              }
            } else {
              this.setState({ comment_data: comments, ValidToken: false });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  /*
  ------------------------------------
    Function to toggle Flash box
  ------------------------------------
    */
  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  /*
  ---------------------------------------------------------------------
    Function to Save flash Card And display new stored flash card
  ---------------------------------------------------------------------
  */
  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value === '') {
      return;
    }

    var flash_card = document.getElementById('flash_card').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card: flash_card,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/saveFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('flash_card').value = '';
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;

            if (response.success) {
              this.setState({ ValidToken: true });

              //this.setState({getComments : resp.comments});

              if (response.flash_cards.length > 0) {
                this.setState({
                  flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                });
                flash_cards = response.flash_cards.map((items, index) => (
                  //alert(items.id)
                  <li key={index}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({
                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                });
              }
              this.setState({ flash_data: flash_cards });
            } else {
              this.setState({
                ValidToken: false,
                flash_data: flash_cards,
                flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
              });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  /*
  ---------------------------------
    Function to Edit Flash card
  ---------------------------------
  */
  _editFlash = (item, e) => {
    this.setState({
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
    });
    document.getElementById('flash_card').value = item.flash_card;
  };

  /*
  --------------------------------------
     Function to delete flash card
  --------------------------------------
  */
  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/deleteFlashCard', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
        });
        document.getElementById('flash_card').value = '';
        var flash_cards = <p>No Flash Card Found</p>;
        this.setState({ flash_data: flash_cards });
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  //Function to fetch Next question
  _getNext = () => {
    this.setState({ display_loader: 'show_block' });
    this.setState({ validated: false, clicked: false });

    this.setState({
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
    });
    this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
    this.setState({ bookmarkColor: '' });
    this.setState({ save_text: `${language.LC().SAVE_QUESTION}` });
    this.setState({ report_block: 'card hide_block' });
    this.setState({
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      choice_e: 'answer_box',
    });
    document.getElementById('comment').value = '';
    // document.getElementById('ques_comment').value = '';

    var insert_time = {
      token: this.state.token,
      idname: this.state.idname,
      quiz_id: this.state.quiz_id,
      user_time_value: this.state.count,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/insertTimer', insert_time).then(resp => {
      if (resp.success) {
        //console.log('Timer Update Successfull');
      } else {
        //console.log('Fail Timer Update');
      }
    });
    var index_id = this.state.offset + 1;
    if (index_id > 0) {
      this.setState({ previ_block: '' });
    }
    if (this.state.question_length - 1 == index_id) {
      this.setState({ next_block: 'card hide_block' });
    }
    this.setState({ offset: index_id });
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.all_question_id[index_id],
      type: this.state.all_reading_type[index_id],
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(resp => {
      const { questionsbyid } = resp;
      if (resp.success) {
        if (questionsbyid['gmat_reading.type'] === 'case_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_CASE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':case', questionsbyid.case_id)
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
          this.context.router.push({
            pathname: AppRoutes.GMAT_QUIZZES_BEGIN.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_GRAPH_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TABLE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TWOPART_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) + 1)
              .replace(':timer', this.state.count),
          });
        }

        this.setState({
          cases_display: questionsbyid['gmat_case.passage'],
        });
        var data_check = {
          token: this.state.token,
          idname: this.state.idname,
          quiz_id: this.state.quiz_id,
          question_id: this.state.all_question_id[this.state.offset],
          type: this.state.all_reading_type[this.state.offset],
        };
        this.setState({ display_loader: 'hide_block' });
        //console.log(data_check);
        FD.callAPI(App_data.backend_api + '/gmat_quizes/checkAnswered', data_check).then(resp => {
          this.setState({ already_answered_status: resp.message });
        });
        this.setState({ choice_a: 'answer_box' });
        this.setState({ choice_b: 'answer_box' });
        this.setState({ choice_c: 'answer_box' });
        this.setState({ result_block: 'card hide_block' });
        this.setState({ display_question: resp.questionsbyid });

        var params = {
          token: this.state.token,
          question_id: this.state.all_question_id[this.state.offset],
          idname: this.state.idname,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
          response => {
            if (response.success) {
              this.setState({
                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              });
              this.setState({ save_text: `${language.LC().Question_Saved}` });
              this.setState({
                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              });
              this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
            }
          },
        );

        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                flash_cards = response.flash_cards.map(items => (
                  //alert(items.id)
                  <li>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-md-12 display_block' });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-md-12 display_block' });
            }
            return response;
          },
        );

        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.comments.length > 0) {
                comments = response.comments.map(items => (
                  <li>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username},{' '}
                      {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        // console.log(resp.success + '------------failure');
      }
    });
    clearInterval(this.timer);
    if (!this.state.timer_stop) {
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
  };

  _getNextAnyway = () => {
    // console.log(this.state.questions)
    this.setState({
      display_loader: 'show_block',
      showCompletionQuestion: false,
    });
    if (this.props.params.question_number === this.state.casesquestion_length) {
      this.setState({
        validated: false,
        clicked: false,
        rated: false,
        rating: 0,
        ratting_text: 'Rate this Question',
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
        save_text: `${language.LC().SAVE_QUESTION}`,
        timerstopbtn: 'pause_btn icon-control-pause',
        report_block: 'card hide_block',
      });
      const i = 0;
      this.setState({ offset: i });

      this.context.router.push({
        pathname:
          '/cfa2_chapter/' +
          this.props.params.chapterid +
          '/' +
          this.props.params.caseid +
          '/' +
          this.props.params.case_offset +
          '/' +
          this.state.all_questions_state[i].question_number +
          '/' +
          0,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapterid: this.props.params.chapterid,
          caseid: this.props.params.caseid,
          case_offset: this.props.params.case_offset,
          question_number: i,
          offset: 0,
        },
      });
    } else {
      //alert(this.state.casesquestion_length);
      this.setState({
        validated: false,
        rated: false,
        rating: 0,
        ratting_text: 'Rate this Question',
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
        save_text: `${language.LC().SAVE_QUESTION}`,
        timerstopbtn: 'pause_btn icon-control-pause',
        report_block: 'card hide_block',
      });
      const i = this.state.offset + 1;
      this.setState({ offset: i });
      //alert(i);
      this.context.router.push({
        pathname:
          '/cfa2_chapter/' +
          this.props.params.chapterid +
          '/' +
          this.props.params.caseid +
          '/' +
          this.props.params.case_offset +
          '/' +
          this.state.all_questions_state[i].question_number +
          '/' +
          i,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapterid: this.props.params.chapterid,
          caseid: this.props.params.caseid,
          case_offset: this.props.params.case_offset,
          question_number: i,
          offset: i,
        },
      });
    }
  };
  //Function to fetch previous question
  _getPrevious = () => {
    this.setState({ display_loader: 'show_block' });
    this.setState({ validated: false, clicked: false });
    this.setState({
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
    });
    this.setState({ bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark' });
    this.setState({ bookmarkColor: '' });
    this.setState({ save_text: `${language.LC().SAVE_QUESTION}` });
    this.setState({ report_block: 'card hide_block' });
    this.setState({
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      choice_e: 'answer_box',
    });
    document.getElementById('comment').value = '';
    // document.getElementById('ques_comment').value = '';

    var insert_time = {
      token: this.state.token,
      idname: this.state.idname,
      quiz_id: this.state.quiz_id,
      user_time_value: this.state.count,
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/insertTimer', insert_time).then(resp => {
      if (resp.success) {
        console.log('Timer Update Successfull');
      } else {
        console.log('Fail Timer Update');
      }
    });

    var index_id = this.state.offset - 1;
    if (this.state.question_length - 1 != index_id) {
      this.setState({ next_block: '' });
    }
    this.setState({ offset: index_id });
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: this.state.all_question_id[index_id],
      type: this.state.all_reading_type[index_id],
    };
    FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(resp => {
      if (resp.success) {
        const { questionsbyid } = resp;
        if (questionsbyid['gmat_reading.type'] === 'case_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_CASE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':case', questionsbyid.case_id)
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'tab_question') {
          this.context.router.push({
            pathname: AppRoutes.GMAT_QUIZZES_BEGIN.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'graph_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_GRAPH_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'table_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TABLE_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else if (questionsbyid['gmat_reading.type'] === 'two_part_question') {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_TWOPART_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':type', questionsbyid['gmat_reading.type'])
              .replace(':timer', this.state.count),
          });
        } else {
          this.context.router.push({
            pathname: AppRoutes.BEGIN_QUIZ.replace(':quiz_id', this.state.quiz_id)
              .replace(':offset', parseInt(this.props.params.offset) - 1)
              .replace(':timer', this.state.count),
          });
        }

        // this.context.router.push({
        //   pathname: AppRoutes.BEGIN_QUIZ.replace(
        //     ':quiz_id',
        //     this.state.quiz_id
        //   ).replace(':offset', parseInt(this.props.params.offset) - 1),

        //   //   `/gmat_beginquiz/${this.state.quiz_id}/${parseInt(
        //   //   this.props.params.offset
        //   // ) - 1}`,
        // });

        this.setState({
          cases_display: questionsbyid['gmat_case.passage'],
          display_loader: 'hide_block',
        });
        var data_check = {
          token: this.state.token,
          idname: this.state.idname,
          quiz_id: this.state.quiz_id,
          question_id: this.state.all_question_id[this.state.offset],
          type: this.state.all_reading_type[this.state.offset],
        };
        FD.callAPI(App_data.backend_api + '/gmat_quizes/checkAnswered', data_check).then(resp => {
          this.setState({ already_answered_status: resp.message });
        });
        this.setState({ choice_a: 'answer_box' });
        this.setState({ choice_b: 'answer_box' });
        this.setState({ choice_c: 'answer_box' });
        this.setState({ result_block: 'card hide_block' });
        this.setState({ display_question: resp.questionsbyid });

        var params = {
          token: this.state.token,
          question_id: this.state.all_question_id[this.state.offset],
          idname: this.state.idname,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
          response => {
            if (response.success) {
              this.setState({
                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              });
              this.setState({ save_text: `${language.LC().Question_Saved}` });
              this.setState({
                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              });
              this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
            }
          },
        );

        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 hide_block' });
                flash_cards = response.flash_cards.map(items => (
                  <li>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-sm-12 display_block' });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-sm-12 display_block' });
            }
            return response;
          },
        );
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
          response => {
            var comments = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.comments.length > 0) {
                comments = response.comments.map(items => (
                  <li>
                    {response.user_id == items.uid ? (
                      <ul className='icon_list'>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._editComment.bind(this, items)}
                          >
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteComment.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                    ) : (
                      <ul />
                    )}
                    <h4>
                      {language.LC().BY} {items.username},{' '}
                      {new Date(items.createdAt).toDateString()}
                    </h4>
                    <p>{items.comment}</p>
                  </li>
                ));
                this.setState({ comment_data: comments });
              } else {
                comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                this.setState({ comment_data: comments });
              }
            } else {
              comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
              this.setState({ comment_data: comments });
              this.setState({ ValidToken: false });
            }
            return response;
          },
        );
      } else {
        // console.log(resp.success + '------------failure');
      }
    });
    clearInterval(this.timer);
    if (!this.state.timer_stop) {
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
  };
  _getNextCase = () => {
    this.setState({
      display_cases: 'hide_block',
      display_subcription: 'hide_block',
      clicked: false,
    });
    const casesoffset = parseInt(this.props.params.case_offset, 10) + 1;
    var caseid = '';
    if (this.state.cases_length > casesoffset) {
      this.setState({
        cases_offset: casesoffset,
      });
      caseid = this.state.all_cases[casesoffset].case_id;

      this.context.router.push({
        pathname: AppRoutes.GMAT_BEGINCASE.replace(':chapterid', this.props.params.chapterid)
          .replace(':readingid', this.props.params.readingid)
          .replace(':caseid', caseid)
          .replace(':case_offset', casesoffset)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_number', this.state.all_cases[casesoffset].question_no)
          .replace(':offset', 0),
      });
      //this.setState({all_cases:caseid});
      // this.context.router.push({
      //   pathname:
      //     '/cfa2_chapter/' +
      //     this.props.params.chapterid +
      //     '/' +
      //     caseid +
      //     '/' +
      //     casesoffset +
      //     '/' +
      //     '1' +
      //     '/' +
      //     0,
      //   state: {
      //     token: this.state.token,
      //     idname: this.state.idname,
      //     chapterid: this.props.params.chapterid,
      //     caseid: caseid,
      //     case_offset: casesoffset,
      //     question_number: 1,
      //     offset: 0,
      //   },
      // });
    } else {
      this.setState({ cases_offset: 0 });
      caseid = this.state.all_cases[0].id;
    }
  };

  _getPreviousCase = () => {
    this.setState({
      display_cases: 'hide_block',
      display_subcription: 'hide_block',
      clicked: false,
    });
    // const casesoffset = parseInt(this.state.cases_offset, 10) + 1;
    const casesoffset = this.props.params.case_offset - 1;
    let caseid = this.state.all_cases[casesoffset].case_id;
    if (this.state.cases_offset === 0) {
      this.setState({
        cases_offset: casesoffset,
      });
    } else {
      this.setState({ cases_offset: casesoffset });
      this.context.router.push({
        pathname: AppRoutes.GMAT_BEGINCASE.replace(':chapterid', this.props.params.chapterid)
          .replace(':readingid', this.props.params.readingid)
          .replace(':caseid', caseid)
          .replace(':case_offset', casesoffset)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_number', this.state.all_cases[casesoffset].question_no)
          .replace(':offset', 0),
      });
    }
  };
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.params.question_number !== this.props.params.question_number &&
      nextProps.params.caseid === this.props.params.caseid
    ) {
      // console.log('I am here for pffset ----. ', nextProps.params.offset);
      this._changeQuestion(
        nextProps.params.chapterid,
        nextProps.params.caseid,
        nextProps.params.case_offset,
        nextProps.params.question_number,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      // this.setState({ display_loader: 'show_block' });
    }

    if (nextProps.params.caseid !== this.props.params.caseid) {
      this._changeCase(
        nextProps.params.chapterid,
        nextProps.params.caseid,
        nextProps.params.case_offset,
        nextProps.params.question_number,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      this.setState({ display_loader: 'show_block' });
    }
  }

  /*
------------------------------------------------------
  on url question offset change run this function
-------------------------------------------------------
*/

  _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
    // console.log('all_cases ----> ', case_offset);
    // console.log('all_questions_state -----> ', question_number);
    this.setState({
      case_id: caseid,
      display_main_loader: 'show_block',
      display_cases: 'hide_block',
      top_50: 'top-50',

      ValidToken: true,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      choice_e: 'answer_box',
      result_block: 'card hide_block',
      rated: false,
      rating: 0,
      ratting_text: 'Rate this Question',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
    });
    // var data = {
    //   token: token_id,
    //   idname: idname,
    //   chapter_id: chapterid,
    //   reading_id: this.props.params.readingid,
    //   case_id: caseid,
    // };
    const { all_questions_state } = this.state;
    let offset_res = '';
    let questionid = '';
    // console.log(questionid);
    for (var i = 0; i < all_questions_state.length; i++) {
      if (i === parseInt(offset_val, 10)) {
        this.setState({
          hide_question_left_arrow: '',
          hide_question_right_arrow: '',
        });
        if (i === 0)
          this.setState({
            hide_question_left_arrow: 'menu_hide',
          });
        else if (i === all_questions_state.length - 1)
          this.setState({
            hide_question_right_arrow: 'menu_hide',
          });
        offset_res = i;
        questionid = all_questions_state[i].id;
        // console.log(all_questions_state[i]);
        this.setState({
          questions: all_questions_state[i],
          offset: offset_res,
          display_main_loader: 'hide_block',
          top_50: '',
          question_no: i + 1,
        });
        this.getFavQuestions(all_questions_state[i].id);
        this.getGMATRatting(all_questions_state[i].id);
        this.getComments(all_questions_state[i].id);
        this.getFlashCards(all_questions_state[i].id);
      }
      if (i === all_questions_state.length - 1) {
        this.setState({
          display_loader: 'hide_block',
          display_cases: 'show_block',
        });
      }
    }
    // this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
    // clearInterval(this.timer);
    // this.timer = setInterval(this.tick.bind(this), 1000);

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-MML-AM_CHTML'; // use the location of your MathJax

    document.getElementsByTagName('head')[0].appendChild(script);
  }

  _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
    let data = {
      token: token_id,
      idname: idname,
      chapter_id: chapterid,
      case_id: caseid,
      reading_id: this.props.params.readingid,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    this.setState({
      cases_display: '',
      cases_name: '',
    });

    this.setState({ case_id: caseid });
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getCaseByReading', data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          choice_a: 'answer_box',
          choice_b: 'answer_box',
          choice_c: 'answer_box',
          choice_d: 'answer_box',
          choice_e: 'answer_box',
          result_block: 'card hide_block',
          rated: false,
          rating: 0,
          ratting_text: 'Rate this Question',
          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
          save_text: `${language.LC().SAVE_QUESTION}`,
          timerstopbtn: 'pause_btn icon-control-pause',
          report_block: 'card hide_block',
          display_main_loader: 'show_block',
          top_50: 'top-50',
          // hide_question_right_arrow: 'menu_show',
          // hide_question_left_arrow: 'menu_hide',
        });
        document.getElementById('comment').value = '';
        this.setState({ all_cases: resp.questions });
        for (var i = 0; i < resp.questions.length; i++) {
          if (parseInt(this.props.params.case_offset, 10) === i) {
            this.setState({
              hide_case_left_arrow: '',
              hide_case_right_arrow: '',
            });
            if (i === 0) this.setState({ hide_case_left_arrow: 'menu_hide' });
            else if (i === resp.questions.length - 1)
              this.setState({ hide_case_right_arrow: 'menu_hide' });

            this.setState({
              cases_display: resp.questions[i]['gmat_case.passage'],
              cases_name: 'Case no : ' + (parseInt(i, 10) + 1),
            });
          }
        }
        this.setState({ display_loader: 'hide_block' });
        var param = {
          token: token_id,
          idname: idname,
          case_id: caseid,
          reading_id: this.props.params.readingid,
          subscriptionstatus: this.state.subscriptionstatus,
        };
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getCasesquestion', param).then(
          resp_question => {
            if (resp_question.success) {
              this.setState({
                casesquestion_length: resp_question.questions_details.length,
                display_main_loader: 'hide_block',
              });
              // console.log(
              //   'I am having a issue here -------->',
              //   resp_question.questions_details.length,
              //   question_number,
              //   offset_val
              // );
              if (resp_question.questions_details.length > offset_val) {
                //let ques_res=[];

                let offset_res = '';
                let questionid = '';
                // console.log(questionid);

                for (var i = 0; i < resp_question.questions_details.length; i++) {
                  // console.log(
                  //   'resp_question.questions_details[i].length',
                  //   resp_question.questions_details.length
                  // );
                  if (i === 0) {
                    this.setState({
                      hide_question_left_arrow: '',
                      hide_question_right_arrow: '',
                    });
                    if (i === 0)
                      this.setState({
                        hide_question_left_arrow: 'menu_hide',
                      });
                    if (i === resp_question.questions_details.length - 1)
                      this.setState({
                        hide_question_right_arrow: 'menu_hide',
                      });
                    offset_res = i;
                    questionid = resp_question.questions_details[i].id;
                    this.setState({
                      questions: resp_question.questions_details[i],
                      question_no: i + 1,
                    });
                    this.getFavQuestions(resp_question.questions_details[i].id);
                    this.getGMATRatting(resp_question.questions_details[i].id);
                    this.getComments(resp_question.questions_details[i].id);
                    this.getFlashCards(resp_question.questions_details[i].id);
                  }
                  if (i === resp_question.questions_details.length - 1) {
                    this.setState({ display_loader: 'hide_block' });
                  }
                }
                this.setState({
                  offset: offset_res,
                  all_questions_state: resp_question.questions_details,
                  display_cases: 'show_block',
                  top_50: '',
                });
                this.setState({ records: '' });
              } else {
                console.log('Not Valid');
              }
            }
          },
        );
      } else {
        this.setState({ ValidToken: false, records: 'Result not found.' });
      }
      clearInterval(this.timer);
      this.timer = setInterval(this.tick.bind(this), 1000);
      return resp;
    });
    this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
    // clearInterval(this.timer);
    // this.timer = setInterval(this.tick.bind(this), 1000);
  }

  _getSubscribe = () => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  // ==================== CHANGES BY ME START ==============================//
  expandScreen = () => {
    this.setState({
      isExpand: true,
    });
    var elem = document.getElementById('Progress1');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  };
  closeFullscreen = () => {
    this.setState({
      isExpand: false,
    });
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
  };
  // ==================== CHANGES BY ME END ==============================//
  // =============================== TODO END =======================//
  async componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
      display_loader: 'show_block',
      // display_cases: 'hide_block',
      quiz_id: this.state.quiz_id,
    });
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      quiz_id: this.state.quiz_id,
    };
    //Api to fetch Quiz by quiz id
    FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuize', data).then(resp => {
      if (resp.success) {
        var retun_all_question = JSON.stringify(resp.singlequiz);
        var all_questions = JSON.parse(JSON.parse(retun_all_question)).all_questions;
        let readings = JSON.parse(JSON.parse(retun_all_question)).readings;
        var question_id = [];
        var reading_id = [];
        for (var i = 0; i < resp.questions_count; i++) {
          question_id.push(all_questions[i]);
          reading_id.push(readings[i]);
        }
        var timer_value = resp.timer_value;

        var first_question_id = question_id[this.state.offset];
        var first_reading_type = reading_id[this.state.offset];
        var user_timer = resp.user_time_value;
        this.setState({
          user_time_value: user_timer,
          count: resp.user_time_value ? resp.user_time_value : parseInt(this.props.params.timer),
          count_temp: user_timer,
        });
        this.setState({
          all_question_id: question_id,
          question_length: question_id.length,
          timer_value: timer_value,
          include_timer: resp.include_timer,
          first_question_id: first_question_id,
          first_reading_type: first_reading_type,
          all_reading_type: reading_id,
        });

        if (question_id.length - 1 == this.state.offset) {
          this.setState({ next_block: 'card hide_block' });
        }

        var data = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: first_question_id,
          type: first_reading_type,
        };
        //Api to fetch question by question id
        FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuestionsbyid', data).then(resp => {
          if (resp.success) {
            var data_check = {
              token: this.state.token,
              idname: this.state.idname,
              quiz_id: this.state.quiz_id,
              question_id: first_question_id,
              type: first_reading_type,
            };
            /*Api to fetch question and check answered */
            FD.callAPI(App_data.backend_api + '/gmat_quizes/checkAnswered', data_check).then(
              resp_inner => {
                this.setState({ already_answered_status: resp_inner.message });
              },
            );
            // console.log('esp.questionsbyid-----', resp.questionsbyid);
            this.setState({ ValidToken: true });
            this.setState({
              display_question: resp.questionsbyid,
              cases_display: resp.questionsbyid['gmat_case.passage'],
            });
            this.setState({ display_loader: 'hide_block' });
            var params = {
              token: this.state.token,
              question_id: first_question_id,
              idname: this.state.idname,
              type: first_reading_type,
            };
            /*Api to fetch Saved question */
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params).then(
              response => {
                if (response.success) {
                  this.setState({
                    save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                  });
                  this.setState({
                    bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                  });
                  this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
                  this.setState({
                    save_text: `${language.LC().Question_Saved}`,
                  });
                }
              },
            );
            var params = {
              token: this.state.token,
              idname: this.state.idname,
              quiz_id: this.state.quiz_id,
              question_id: first_question_id,
            };
            /*Api to fetch commented on question*/
            FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(
              response => {
                if (response.success) {
                  var comments = '';
                  this.setState({ ValidToken: true });
                  if (response.comments.length > 0) {
                    comments = response.comments.map((items, index) => (
                      <li key={index}>
                        {response.user_id == items.uid ? (
                          <ul className='icon_list'>
                            <li>
                              <a
                                className='pointer_class'
                                onClick={this._editComment.bind(this, items)}
                              >
                                <i className='fa fa-pencil' />
                              </a>
                            </li>
                            <li>
                              <a
                                className='pointer_class'
                                onClick={this._deleteComment.bind(this, items)}
                              >
                                <i className='fa fa-close' />
                              </a>
                            </li>
                          </ul>
                        ) : (
                          <ul />
                        )}

                        <h4>
                          {language.LC().BY} {items.username},{' '}
                          {new Date(items.createdAt).toDateString()}
                        </h4>
                        <p>{items.comment}</p>
                      </li>
                    ));

                    this.setState({ comment_data: comments });
                  } else {
                    comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                    this.setState({ comment_data: comments });
                  }
                } else {
                  comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
                  this.setState({ comment_data: comments });
                  this.setState({ ValidToken: false });
                }
                return response;
              },
            );
          } else {
            // console.log(resp.success + '------------failure');
          }
        });

        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: first_question_id,
          quiz_id: this.state.quiz_id,
        };
        /*Api to fetch flash card*/
        FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
          response => {
            var flash_cards = '';
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                flash_cards = response.flash_cards.map(items => (
                  //alert(items.id)
                  <li>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
              } else {
                this.setState({ flash_form: 'col-md-12 display_block' });
                flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              }
              this.setState({ flash_data: flash_cards });
            } else {
              flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({ ValidToken: false });
              this.setState({ flash_data: flash_cards });
              this.setState({ flash_form: 'col-md-12 display_block' });
            }
            return response;
          },
        );
      } else {
        // console.log(resp.success + '------------failure');
      }
      return resp;
    });
    // -------------------------- CASE AND Question ---------------- //
    clearInterval(this.timer);
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  getFavQuestions = questionid => {
    var params_fav = {
      token: storage_session['token'],
      question_id: questionid,
      idname: storage_session['idname'],
      chapter_id: this.props.params.chapterid,
    };
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFavQuestions', params_fav).then(
      response => {
        if (response.success) {
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        }
      },
    );
  };
  getGMATRatting = questionid => {
    // console.log('I am inside getGMATRatting', questionid);
    var params = {
      token: storage_session['token'],
      question_id: questionid,
      idname: storage_session['idname'],
    };
    //Api to get ratting
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getGMATRatting', params).then(
      response => {
        if (response.success) {
          this.setState({ rated: true });
          response.ratting.map(items =>
            this.setState({
              rating: items.ratting,
              ratting_text: 'Rated ',
            }),
          );
        }
      },
    );
  };
  getComments = questionid => {
    var params = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      question_id: questionid,
    };
    //Api to fetch Comment
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getComments', params).then(response => {
      //console.log(response);
      let comments = <p>{language.LC().NO_COMMENTS_FOUND}</p>;
      if (response.success) {
        this.setState({ ValidToken: true });
        //console.log(response)           ;
        if (response.comments.length > 0) {
          comments = response.comments.map((items, index) => (
            <li key={index}>
              {response.user_id === items.uid ? (
                <ul className='icon_list'>
                  <li>
                    <a className='pointer_class' onClick={this._editComment.bind(this, items)}>
                      <i className='fa fa-pencil' />
                    </a>
                  </li>
                  <li>
                    <a className='pointer_class' onClick={this._deleteComment.bind(this, items)}>
                      <i className='fa fa-close' />
                    </a>
                  </li>
                </ul>
              ) : (
                <ul />
              )}

              <h4>
                {language.LC().BY} {items.username}, {new Date(items.createdAt).toDateString()}
              </h4>
              <p>{items.comment}</p>
            </li>
          ));

          this.setState({ comment_data: comments });
        } else {
          this.setState({ comment_data: comments });
        }
      } else {
        this.setState({
          comment_data: comments,
          ValidToken: false,
        });
      }
      return response;
    });
  };
  getFlashCards = questionid => {
    var params = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      question_id: questionid,
    };
    //Api to fetch flashcard by question id
    FD.callAPI(App_data.backend_api + '/gmat_question_bank/getFlashCards', params).then(
      response => {
        let flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        if (response.success) {
          this.setState({ ValidToken: true });
          if (response.flash_cards.length > 0) {
            this.setState({
              flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
            });
            flash_cards = response.flash_cards.map((items, index) => (
              <li key={index}>
                <div className=''>
                  <ul className='icon_list'>
                    <li>
                      <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                        <i className='fa fa-pencil' />
                      </a>
                    </li>
                    <li>
                      <a className='pointer_class' onClick={this._deleteFlash.bind(this, items)}>
                        <i className='fa fa-close' />
                      </a>
                    </li>
                  </ul>
                  <div className={this.state.flash_class}>
                    <h4 />
                    <p>{items.flash_card}</p>
                  </div>
                </div>
              </li>
            ));
          } else {
            this.setState({
              flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
            });
          }
          this.setState({ flash_data: flash_cards });
        } else {
          this.setState({
            ValidToken: false,
            flash_data: flash_cards,
            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
          });
        }
        return response;
      },
    );
  };
  checkSubscription = (SubscriptionFile, resp, resp_cases) => {
    if (
      resp.profileInfo.exam_selected === '' &&
      resp.profileInfo.cfaUnlimitedPackage === '' &&
      resp.profileInfo.cfaUnlimitedActiveExam === ''
    ) {
      //here code for check case id free or not
      this.setState({
        subscriptionstatus: 'free',
      });
      if (resp_cases.casesingleData.free === 0) {
        this.setState({
          display_cases: 'hide_block',
          display_subcription: 'show_block',
        });
        this.toggleAlert();
      } else {
        this.setState({
          display_cases: 'show_block',
          display_subcription: 'hide_block',
        });
      }
    } else {
      this.setState({
        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
      });
      //console.log(resp_cases.casesingleData.free+'----------');
      var data_arr = resp.profileInfo.exam_selected
        ? JSON.parse(resp.profileInfo.exam_selected)
        : null;
      var dataset = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        examid: data_arr,
      };
      FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(resp_exam => {
        if (resp_exam.success) {
          var exam_data = resp_exam.examData;
          var selectedmen = this.state.selectedmenu;
          var isInArray_var = false;
          isInArray_var = SubscriptionFile.checkCfa2Subscription(
            selectedmen,
            exam_data,
            this.state.cfaUnlimitedPackage,
            this.state.cfaUnlimitedActiveExam,
          );
          if (isInArray_var) {
            this.setState({
              subscriptionstatus: 'paid',
              display_cases: 'show_block',
              display_subcription: 'hide_block',
            });
          } else {
            if (resp_cases.casesingleData.free === 0) {
              this.setState({
                display_cases: 'hide_block',
                display_subcription: 'show_block',
              });
            } else {
              this.setState({
                subscriptionstatus: 'free',
                display_cases: 'show_block',
                display_subcription: 'hide_block',
              });
            }
          }
        } else {
          console.log('fail');
        }
      });
    }
  };

  //Function to redirect page to readings beforestart
  _getSummary = () => {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', this.state.quiz_id).replace(
        ':status_send',
        'abondon',
      ),
    });
  };

  render() {
    let questions_data_display = this.state.display_question;
    let questions = this.state.display_question;

    let count_temp_var = this.state.count;
    let display_time = '';
    if (count_temp_var < 60) {
      display_time = count_temp_var + 'sec';
    } else {
      var temp_min = Math.trunc(count_temp_var / 60);
      var temp_sec = Math.trunc(count_temp_var % 60);
      display_time = temp_min + 'min ' + temp_sec + 'sec';
    }
    const { reportLoading } = this.state;
    const choice_a = 'a';
    const choice_b = 'b';
    const choice_c = 'c';
    const choice_d = 'd';
    const choice_e = 'e';
    let question_data = '';
    this.state.showCompletionQuestion
      ? (question_data = (
        <div className='w-100'>
          <div className={'card-block ' + this.state.display_subcription}>
            <div className='row'>
              <div className='col-md-12'>
                <div className='card 23434'>
                  <span>{language.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY}</span>
                </div>
              </div>
            </div>
          </div>
          <div className={'col-md-12 complete-section-wrap ' + this.state.display_cases}>
            <div className='card'>
              <div className='card-header text-center'>
                {/* <img src={App_data.frontend_url+"/img/question_bank/question_icon_blue.svg"} className="margin_right_20" alt="" width="30" /> */}
                {language.LC().Mark_this_Question_as_Completed}
                {/* <button onClick = {this._getNextAnyway} > Go To Question 1 </button> */}
                <div onClick={this._getNextAnyway} className='float-right text-right'>
                  <i className='fa fa-angle-right ques_arrow pointer_class' />
                </div>
              </div>

              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 text-center'>
                    <div className='row'>
                      <div className='col-sm-12 col-md-12 '>
                        <div className='quation-img'>
                          <img
                            src={
                              App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'
                            }
                            className='margin_bottom_10'
                            alt=''
                          />
                        </div>
                        <div
                          contentEditable='false'
                          suppressContentEditableWarning={true}
                          className='margin_bottom_10 view_questionhtml bg_blue'
                        >
                          {' '}
                          {language.LC().MARK_THIS_QUESTION_AS_COMPLETED}{' '}
                        </div>
                      </div>
                      <div className='complete-or-not-wrap'>
                        <div className='check-button-wrap'>
                          <div className='card-actions float-right'>
                            <label className='check_container margin_bottom_0'>
                              {' '}
                              {language.LC().COMPLETED}
                              <input
                                type='checkbox'
                                id='mark_completed'
                                name='mark_completed'
                                value='select'
                                onClick={this.markCompleted.bind(this)}
                                checked={this.state.markAsCompleted}
                              />
                              <span className='checkmark' />
                            </label>
                          </div>
                          <div className='card-actions float-right'>
                            <label className='check_container margin_bottom_0'>
                              {language.LC().NOT_COMPLETED}
                              <input
                                type='checkbox'
                                id='mark_not_completed'
                                name='mark_not_completed'
                                value='select'
                                onClick={this.markNotCompleted.bind(this)}
                                checked={this.state.markAsNotCompleted}
                              />
                              <span className='checkmark' />
                            </label>
                          </div>
                        </div>
                        <div className='d-block text-center complete-quation-submit'>
                          <button
                            disabled={this.state.markCompleted}
                            onClick={this.changeCompletionStatus.bind(this)}
                            className='btn btn-primary pointer_class'
                          >
                            {' '}
                            {language.LC().SUBMIT}{' '}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))
      : (question_data = (
        <div className='note-section'>
          <div className={'card-block ' + this.state.display_subcription}>
            <div className='row'>
              <div className='col-sm-12 col-md-12 p-sm-0'>
                <div className='card'>
                  <div className='card-header'>
                    <h4>{language.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <Loader /> */}
          <div className={'col-sm-12 col-md-12 p-sm-0 ' + this.state.display_cases}>
            <div className='card box-shadow-none'>
              {/* <div className='card-header title-font-size'>
                  <div className='d-flex justify-content-between'>
                    <div className='d-flex'>
                      <img
                        src={
                          App_data.frontend_url +
                          '/img/question_bank/question_icon_blue.svg'
                        }
                        className='margin_right_20'
                        alt=''
                        width='30'
                      />
                      <div className='title-font-size'>
                        {language.LC().QUESTION}{' '}
                        {this.state.question_no + ' - '}
                      </div>
                    </div>
                    <div className='float-right text-right'>
                      <i
                        className={`fa fa-angle-left ques_arrow pointer_class ${
                          this.state.hide_question_left_arrow
                        }`}
                        onClick={this._getPrevious}
                      />
                      <i
                        className={`fa fa-angle-right ques_arrow pointer_class ${
                          this.state.hide_question_right_arrow
                        }`}
                        onClick={this._getNext}
                      />
                    </div>
                  </div>
                </div> */}
              {/* <div className='card-block'> */}
              <div>
                <div className='row px-md-15px'>
                  <div>
                    <div className='row'>
                      <div className='col-sm-12 col-md-12'>
                        {renderHTMLContent(
                          questions_data_display.question,
                          "div",
                          "margin_bottom_40 view_questionhtml bg_blue",
                          { contentEditable: 'false', suppressContentEditableWarning: true }
                        )}
                      </div>
                      <div
                        className='col-sm-12 col-md-12'
                        id='choice_a'
                        onClick={this._getAnswer.bind(this, choice_a, questions_data_display.id)}
                      >
                        <div className={this.state.choice_a}>
                          <div className='answer_count'>{language.LC().A}</div>

                          <p className='ans_box_text'>
                            {renderHTMLContent(
                              questions_data_display.choice_a,
                              "span",
                              "",
                              { contentEditable: 'false', suppressContentEditableWarning: true }
                            )}

                          </p>
                        </div>
                      </div>
                      <div
                        className='col-sm-12 col-md-12'
                        id='choice_b'
                        onClick={this._getAnswer.bind(this, choice_b, questions_data_display.id)}
                      >
                        <div className={this.state.choice_b}>
                          <div className='answer_count'>{language.LC().B}</div>
                          <p className='ans_box_text'>
                            {renderHTMLContent(
                              questions_data_display.choice_b,
                              "span",
                              "",
                              { contentEditable: 'false', suppressContentEditableWarning: true }
                            )}
                          </p>
                        </div>
                      </div>

                      <div
                        className='col-sm-12 col-md-12'
                        id='choice_c'
                        onClick={this._getAnswer.bind(this, choice_c, questions_data_display.id)}
                      >
                        <div className={this.state.choice_c}>
                          <div className='answer_count'>{language.LC().C}</div>

                          <p className='ans_box_text'>
                            {renderHTMLContent(
                              questions_data_display.choice_c,
                              "span",
                              "",
                              { contentEditable: 'false', suppressContentEditableWarning: true }
                            )}
                          </p>
                        </div>
                      </div>
                      <div
                        className='col-sm-12 col-md-12'
                        id='choice_d'
                        onClick={this._getAnswer.bind(this, choice_d, questions_data_display.id)}
                      >
                        <div className={this.state.choice_d}>
                          <div className='answer_count'>{language.LC().D}</div>
                          <p className='ans_box_text'>
                            {renderHTMLContent(
                              questions_data_display.choice_d,
                              "span",
                              "",
                              { contentEditable: 'false', suppressContentEditableWarning: true }
                            )}
                          </p>
                        </div>
                      </div>
                      <div
                        className='col-sm-12 col-md-12'
                        id='choice_e'
                        onClick={this._getAnswer.bind(this, choice_e, questions_data_display.id)}
                      >
                        <div className={this.state.choice_e}>
                          <div className='answer_count'>{language.LC().E}</div>
                          <p className='ans_box_text'>
                            {renderHTMLContent(
                              questions_data_display.choice_e,
                              "span",
                              "",
                              { contentEditable: 'false', suppressContentEditableWarning: true }
                            )}
                          </p>
                        </div>
                      </div>

                      <Col md={12} className='mt-2'>
                        <Row className='align-items-center'>
                          <ValidateSaveReportIcon
                            isQue={true}
                            _getResult={this._getResult}
                            clicked={this.state.clicked}
                            _saveQuestion={this._saveQuestion}
                            _displayReportForm={this._displayReportForm}
                            all_questions={questions_data_display}
                            save_text={this.state.save_text}
                            bookmarkCSS={this.state.bookmarkCSS}
                            bookmarkColor={this.state.bookmarkColor}
                          />
                        </Row>
                      </Col>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${this.state.result_block} bg-faded`}>
              <div className={this.state.text_color}>{this.state.result}</div>
              <div className='card-block'>
                {/* <Latex>{questions_data_display.explanation}</Latex>   */}
                {renderHTMLContent(
                  questions_data_display.answer,
                  "p",
                  "view_questionhtml",
                  { contentEditable: 'false', suppressContentEditableWarning: true }
                )}
              </div>
            </div>

            <div className='row'>
            </div>
          </div>
        </div>
      ));

    // console.log('question_data----------', question_data);
    // const { timer_stop } = this.state;
    return (
      <div className='d-flex flex-column' id='Progress1'>
        {/* ========================= BODY ============================== */}
        <div className='row'>
          <div className='col-sm-8 margin_bottom_20'>
            <h1 className='section_head'>
              {language.LC().QUIZ_ID} : {this.state.quiz_id}
            </h1>
            <h6 className='text-danger'>{this.state.already_answered_status}</h6>
          </div>
          <div className='col-sm-4 margin_bottom_20 text-sm-right'>
            <button className='btn btn-primary pointer_class' onClick={this._getSummary}>
              {' '}
              {language.LC().BACK_TO_SUMMARY}{' '}
            </button>
          </div>
        </div>
        <div className='card py-1'>
          <div className='card-header'>
            <img
              src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
              className='margin_right_20'
              width='30'
              alt=''
            />
            {language.LC().Q} {parseInt(this.state.offset) + 1}{' '}
            <div className='float-right text-right'>
              <i
                className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                onClick={this._getPrevious}
              />
              <i
                className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                onClick={this._getNext}
              />
            </div>
          </div>
          <div className='d-flex flex-sm-col'>
            {/* ============================ CASES ============================= */}
            <div
              className='col-lg-5 mb-0 overflow-y-auto mb-sm-1 font-lusitana bg_blue calc_height_GMAT'
            // style={{ borderRadius: '0px' }}
            >
              {/* <div className='d-flex justify-content-between align-items-center card-header px-0 '>
                <div className='title-font-size'>{this.state.cases_name} </div>
                <div className='float-right text-right'>
                  <i
                    className={`fa fa-angle-left ques_arrow pointer_class ${
                      this.state.hide_case_left_arrow
                    }`}
                    onClick={this._getPreviousCase}
                  />
                  <i
                    className={`fa fa-angle-right ques_arrow pointer_class ${
                      this.state.hide_case_right_arrow
                    }`}
                    onClick={this._getNextCase}
                  />
                </div>
              </div> */}
              <div className='mt-1'>
                {renderHTMLContent(
                  this.state.cases_display,
                  "span",
                  "",
                  { contentEditable: 'false', suppressContentEditableWarning: true }
                )}
              </div>
            </div>
            {/* =============================== TODO QA REPORT START================================== */}
            <div
              className='col-lg-5 mb-0 overflow-y-auto  mb-sm-1  card-border-radius-none bg-white p-2 font-lusitana bg_blue overflow-x-hide calc_height_GMAT'
            // style={{ borderRadius: '0px' }}
            >
              <div className={'position-relative ' + this.state.top_50}>
                <div className={'main_loader ' + this.state.display_main_loader}>
                  <div className='loader-mid'>
                    <div className='card-block-loader'>
                      <Loader />
                    </div>
                  </div>
                  {/* <i className='fa fa-spinner fa-spin ' /> */}
                </div>
                {question_data}
              </div>
            </div>
            {/* --------- Timer --------------- */}
            <div className='col-lg-2 mt-lg-2'>
              <div className='timer_outer'>
                <i className='fa fa-clock-o' />
                <span className='timer_box'>{display_time}</span>
              </div>
              <span className={'quiz_timer_btn ' + this.state.timer_display}>
                <button
                  type='button'
                  className={this.state.timerstopbtn}
                  onClick={this._timer_funct.bind(this, questions)}
                />
              </span>
              <p className='text-danger'>
                {renderHTMLContent(
                  this.state.count_end_message,
                  "div",
                  "",
                  { contentEditable: 'false' }
                )}
              </p>
            </div>
            {/* =============================== TODO QA REPORT END================================== */}
            {/* </div> */}
          </div>
        </div>
        {/* --------------------- Report ---------------------- */}

        <div className='row'>
          <div className='col-md-12'>
            <div className={this.state.report_block}>
              <div className='card-header'>
                {language.LC().REPORT}
                {/* <TooltipItem
                          key="1"
                          id="1"
                          content={this.state.tooltips[1].placement}
                          place_tip={this.state.tooltips[1].text_align}
                        /> */}
              </div>

              {!this.state.successAlert ? (
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-12'>
                      <label className='form-control-label' htmlFor='textarea-input'>
                        <strong>{language.LC().COMMENT}</strong>
                      </label>
                    </div>
                    <div className='col-sm-12 margin_bottom_10'>
                      <textarea
                        id='comment'
                        name='comment'
                        rows='6'
                        className='form-control'
                        placeholder='Content..'
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-sm-12'>
                      <button
                        type='button'
                        className='btn btn-primary active pointer_class margin_bottom_20 report-btn'
                        disabled={reportLoading}
                        onClick={this._reportQuestion.bind(this, questions_data_display)}
                      >
                        {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                      </button>
                      <button
                        type='button'
                        className='btn btn-danger active pointer_class margin_left_10 margin_bottom_20'
                        onClick={this._hideReportForm.bind(this, questions_data_display)}
                      >
                        {language.LC().CANCEL}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-12 report-Success-card'>
                      <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                      <label className='form-control-label' htmlFor='textarea-input'>
                        <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                      </label>
                      <button
                        type='button'
                        className='btn btn-primary active pointer_class  min-vw-120'
                        onClick={this.onClose}
                      >
                        {' '}
                        {language.LC().CLOSE}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* ---------------------- Report --------------------- */}
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

// class TooltipItem extends React.Component {
//   constructor(props) {
//     super(props);

//     this.toggle = this.toggle.bind(this);

//     // document.body.style.backgroundColor = '#1d364b';
//     this.state = {
//       tooltipOpen: false,
//     };
//   }

//   toggle() {
//     this.setState({
//       // tooltipOpen: !tooltipOpen,
//     });
//   }

//   render() {
//     return (
//       <span>
//         <img
//           src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
//           id={'Tooltip-' + this.props.id}
//           width='18'
//           alt=''
//           style={{ marginLeft: '4px' }}
//         />
//         {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

//         <Tooltip
//           placement={this.props.place_tip}
//           // isOpen={tooltipOpen}
//           target={'Tooltip-' + this.props.id}
//           toggle={this.toggle}
//         >
//           <p className='tooltip_text'>{this.props.content}</p>
//         </Tooltip>
//       </span>
//     );
//   }
// }
export default GMATCases;



// WEBPACK FOOTER //
// ./src/views/GMAT/Quizzes/BeginQuiz/BeginCasequiz.js